define('editor/metadata/index',['plugins/router', 'plugins/dialog', 'jquery'], function (router, dialog, $) {
    var viewmodel = function () {
        var self = this;

        self.onSave = function (editorMap) {
            router.navigate('/editor/edit/' + editorMap.id);
        };
        
        self.onFail = function (error) {
            dialog.showMessage("Unable to create map: " + error, "Create Map Failed");
        };

        self.next = function (model, event) {
            var button = $(event.currentTarget),
                theForm = button.closest('[data-view]').find('form'),
                submitButton = theForm.find('[type=submit]');

            submitButton.click(); // makes sure validation happens
        };
    };

    return viewmodel;
});
